import { Component, Input } from '@angular/core';
import { ParkProvider } from '@providers/park.provider';
import { Area } from '@core/area';
import { World } from '@core/world';
import { Kingdom } from '@core/kingdom';
import { BroadcasterService } from '@core/broadcaster/broadcaster.service';
import { LandEvent } from '@core/broadcaster/LandEvent';
import { FormsModule }   from '@angular/forms';
import { NotificationService } from '@core/notification/notification.service';
import { RefreshEvent } from '@events/RefreshEvent';
import {KngActivityIndicatorService} from "@layout/kingswell/services/kngActivityIndicator.service";

@Component({
  selector: 'areas-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.less']
})
export class AreasEditComponent {

  @Input()
  public land: Area;

  constructor(private park: ParkProvider, private kngActivityIndicator: KngActivityIndicatorService,
              private notification: NotificationService, private broadcaster: RefreshEvent) { }

  onSubmit(land: Area, areaId: string) {
    this.park.updateArea(areaId, land).then((res) => {
      this.kngActivityIndicator.close();
      this.notification.show('success', 'You have successfully edited ' + land.name + ".");
      this.broadcaster.fire('refresh.lands');
    });
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/components/areas/edit/edit.component.ts